export default __webpack_public_path__ + "static/media/favicon.b5196cfc.svg";